/** biome-ignore-all lint/suspicious/noArrayIndexKey: fine for skeletons */
import { CardTransactionItemSkeleton } from "Components/CardTransactions/CardTransactionItemSkeleton";

type Props = {
  count: number;
};

export const CardTransactionSkeletons = ({ count }: Props) =>
  Array.from({ length: count }).map((_, index) => (
    <CardTransactionItemSkeleton key={index} />
  ));
